import {Box, Typography} from '@mui/material'
import React from 'react'

interface FieldEditorTitleProps {
  title: string
  subtitle?: string
}

/**
 * FieldEditorTitle Component
 *
 * Displays the field title and optional subtitle (e.g., job site info).
 */
export const FieldEditorTitle: React.FC<FieldEditorTitleProps> = ({title, subtitle}) => {
  return (
    <Box>
      <Typography
        variant="h5"
        sx={{
          color: '#29333D',
          fontWeight: 600,
          fontSize: '20px',
          lineHeight: '24px',
          mb: subtitle ? 0.5 : 0
        }}
        data-test-id="field-editor-title"
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="caption"
          sx={{
            color: '#52667A',
            fontSize: '12px',
            lineHeight: '16px'
          }}
          data-test-id="field-editor-subtitle"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  )
}
